import { combineReducers } from "redux";
import manageadmin from "../features/admin/masters/manageadmin/Slice";
import category from "../features/admin/masters/category/Slice";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import users from "../features/admin/masters/users/Slice";
import manage_ambassador_wallet from "../features/admin/masters/manage_ambassador_wallet/Slice";
import servicecenter from "../features/admin/masters/servicecenter/Slice";
import timeslots from "../features/admin/masters/timeslots/Slice";
import vehicle_type from "../features/admin/masters/vehicle_type/Slice";
import essential_doument from "../features/admin/masters/essential_doument/Slice";
import vehicle_type_category from "../features/admin/masters/vehicle_type_category/Slice";
import ambassador_reasons from "../features/admin/masters/ambassador_reasons/Slice";

const masters = combineReducers({
  manageadmin: manageadmin,
  category: category,
  country: country,
  state: state,
  city: city,
  pincode: pincode,
  users: users,
  servicecenter: servicecenter,
  timeslots: timeslots,
  vehicle_type: vehicle_type,
  essential_doument: essential_doument,
  vehicle_type_category: vehicle_type_category,
  ambassador_reasons: ambassador_reasons,
  manage_ambassador_wallet: manage_ambassador_wallet,
});

export default masters;
